<app-search-bar></app-search-bar>

<div class="content">
  <!-- TITLE / MAIN SLIDER -->
  <app-component-slider></app-component-slider>

  <!-- Info Button, fixed right -->
  <app-info-button></app-info-button>

  <!-- PACKAGES SLIDER -->
  <app-component-packages></app-component-packages>

  <!-- DESTINATIONS -->
  <app-component-destinations *appShellNoRenderer></app-component-destinations>

  <!-- ACTIVITIES -->
  <app-component-activities *appShellNoRenderer></app-component-activities>

  <!-- WHY BOOKYOURTRAIL -->
  <app-why-byt *appShellNoRenderer></app-why-byt>

  <!-- BOOKYOURTRAIL WORLD -->
  <app-about-us *appShellNoRenderer></app-about-us>

  <!-- TrustBox - Testimonials -->
  <app-component-trustbox *appShellNoRenderer></app-component-trustbox>

  <!-- Partners -->
  <app-component-partners *appShellNoRenderer></app-component-partners>

  <!-- Supports -->
  <app-component-supporters *appShellNoRenderer></app-component-supporters>
</div>
